import { useEffect } from 'react'
import { useQuery } from '@tanstack/react-query'
import { wabaApi } from '@/api/endpoints/waba'
import { queryKeys } from '@/api/query-keys'
import { useAuthStore } from '@/stores/authStore'
import { DEFAULT_COMPANY_TIMEZONE, setCompanyTimezone } from '@/lib/company-timezone'
import type { Company } from '@/types'

/**
 * Returns the company's configured timezone (default: Asia/Kolkata).
 * Also syncs the active timezone used by formatDate / DateTimeDisplay helpers.
 */
export function useCompanyTimezone(): string {
  const user = useAuthStore((s) => s.user)

  const companyId = typeof user?.company === 'object'
    ? (user?.company as Company)?.id
    : user?.company
  const cid = companyId ? String(companyId) : ''

  const { data } = useQuery({
    queryKey: queryKeys.company(cid),
    queryFn: () => wabaApi.getCompany(cid),
    enabled: !!cid,
    staleTime: 10 * 60 * 1000,
  })

  const timezone = data?.timezone
    || (typeof user?.company === 'object' ? (user.company as Company)?.timezone : undefined)
    || DEFAULT_COMPANY_TIMEZONE

  useEffect(() => {
    setCompanyTimezone(timezone)
  }, [timezone])

  return timezone
}
